var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9282 11.8999L8.46411 15.5L5 11.8999L7.66528 11.9001V5.50024H9.26526V11.9001L11.9282 11.8999Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92822 4.1001L3.46411 0.5L0 4.1001L2.66528 4.09985V10.4998H4.26526V4.09985L6.92822 4.1001Z",
    fill: "#D4DBE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortActive);
export default __webpack_public_path__ + "static/media/icon-sort-active.7e418bcac5699da4558dba364a5fd0eb.svg";
export { ForwardRef as ReactComponent };